import gql from 'graphql-tag';

export const GET_PRODUCT_CHANGELOG = gql`
  query ProductChangelog($input: AftermarketProductChangelogInput!) {
    result: aftermarketProductChangelog(input: $input) {
      error
      success

      pagination {
        page
        total
        perPage
        totalPages
      }

      items {
        id
        changes
        productId
        changeType
        createdDateTime
        modifiedBy {
          id
          fullName
        }
      }
    }
  }
`;
